import { Router } from '@angular/router'

export function isLoginNavigation(router: Router): boolean {
    const navigation = router.getCurrentNavigation?.()
    const destination = navigation?.finalUrl ?? navigation?.extractedUrl
    return (destination?.toString() ?? router.url).split(/[?#]/, 1)[0] === '/login'
}
